/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostSpendByTagLevelWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("CostSpendByTagLevelWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return CostSpendByTagLevelWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<CostSpendByTagLevelWidgetConfiguration>): CostSpendByTagLevelWidgetConfiguration {
        let obj = Object.assign(new CostSpendByTagLevelWidgetConfiguration(), model);
        CostSpendByTagLevelWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostSpendByTagLevelWidgetConfiguration>): CostSpendByTagLevelWidgetConfiguration {
        if (!model) return null;
        return CostSpendByTagLevelWidgetConfiguration.newInstance(<CostSpendByTagLevelWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostSpendByTagLevelWidgetConfiguration) {
        if (!obj) return;

        models.CostSpendByTagLevelWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostSpendByTagLevelWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostSpendByTagLevelWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Type of Tag Level
     */
    tagLevelType: models.TagLevelType;

}
